<template>
  <div class="table-container">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <validation-observer ref="observer" v-slot="{ invalid, handleSubmit }">
          <b-form @submit.prevent="">
            <div class="form-card-wrapper">
              <b-card header-tag="header">
                <template #header>
                  <b>Contenuto</b>
                </template>
                <b-card-text>
                  <b-row>
                    <div class="form-group">
                      <base-input
                        name="title"
                        vid="title"
                        label="Titolo"
                        v-model="form[rep].title"
                        placeholder="Inserisci un titolo"
                        :rules="{ required: true }"
                      />
                    </div>
                    <div class="form-group">
                      <base-select
                        name="type"
                        label="Tipo"
                        v-model="form[rep].type"
                        :options="types"
                        :taggable="false"
                        :multiple="false"
                        :rules="{ required: true }"
                        @select="onSelectType"
                      />
                    </div>
                    <div class="form-group">
                      <base-select
                        name="type"
                        label="Seleziona Preset"
                        v-model="form.preset"
                        :options="presets"
                        @input="onSelectPreset"
                        :taggable="false"
                        :multiple="false"
                      />
                    </div>
                    <div class="form-group mt-3 py-2">
                      <b-button
                        type="button"
                        class="btn--smaller"
                        variant="lisaweb"
                        @click="onLoadPreset"
                        size="sm"
                      >
                        Carica Preset
                      </b-button>
                    </div>
                  </b-row>
                  <div class="form-group">
                    <base-input
                      name="subject"
                      vid="subject"
                      label="Oggetto Email"
                      v-model="form[rep].subject"
                      maxlength="500"
                      placeholder="Inserisci oggetto email"
                      :rules="{ required: true }"
                    />
                  </div>
                  <!-- <div :class="['col-md-12', tagType]"> -->
                  <div class="form-group" :data-type="tagType">
                    <label>Testo Email:</label>
                    <base-editor
                      editor_id="email_text"
                      :tag_type="tagType"
                      :height="500"
                      :image_list="images"
                      v-model="form[rep].email"
                      @updateEditorContent="updateEditorContent"
                    />
                  </div>
                </b-card-text>
              </b-card>
            </div>
            <div class="form-actions form-actions--sticky">
              <div class="inner-wrapper">
                <div>
                  <span
                    :title="`${
                      invalid
                        ? 'Compila correttamente i campi per poter salvare'
                        : 'Invia il form'
                    }`"
                  >
                    <b-button
                      @click="handleSubmit(onSubmit)"
                      type="button"
                      :disabled="invalid"
                      variant="lisaweb"
                      size="sm"
                    >
                      Salva
                    </b-button></span
                  >
                  <b-button
                    type="button"
                    variant="lisaweb"
                    size="sm"
                    @click="showEmailPreview"
                  >
                    Preview
                  </b-button>
                </div>
                <div>
                  <b-button
                    @click="$router.back()"
                    size="sm"
                    class="btn--transparent"
                    title="Torna alla pagina precedente"
                  >
                    <b-icon-chevron-double-left
                      font-scale="0.9"
                    ></b-icon-chevron-double-left>
                    Torna indietro
                  </b-button>
                </div>
              </div>
            </div>
          </b-form>
        </validation-observer>
        <email-preview-modal
          :subject="form[rep].subject"
          :email="form[rep].email"
        >
        </email-preview-modal>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
    <div class="is-saving-template" v-show="isSavingTemplate"></div>
  </div>
</template>

<script>
import ShortcutMixin from "@/mixins/ShortcutMixin";
import LisaComunicaMixin from "@/mixins/LisaComunicaMixin";
import BaseSelect from "@/components/form/BaseSelect";
import BaseInput from "@/components/form/BaseInput";
import BaseEditor from "@/components/form/BaseEditor";
import EmailPreviewModal from "@/components/modals/emailPreviewModal";

export default {
  mixins: [ShortcutMixin, LisaComunicaMixin],
  data() {
    return {
      isLoading: false,
      isSavingTemplate: false,
      repository: "email",
      id: this.$route.params.id,
      exceptions: ["title", "type"],
      types: [
        { value: "AVV_SCAD", text: "Avvisi scadenza" },
        { value: "MKTG", text: "Marketing" },
        { value: "SOLL", text: "Solleciti" },
        { value: "REN_PRO", text: "Rendiconti" },
      ],
      images: [],
      presets: [],
      tagType: null,
      form: {
        preset: null,
        email: {
          title: null,
          type: null,
          subject: null,
          email: null,
        },
      },
      updated_content: null,
    };
  },
  components: {
    BaseInput,
    BaseSelect,
    BaseEditor,
    EmailPreviewModal,
  },
  methods: {
    updateEditorContent(contentHtml) {
      console.log("contentHtml", contentHtml);
      this.updated_content = contentHtml;
    },
    onSelectType(selected) {
      console.debug("TEST:", selected);
      this.tagType = selected;
    },
    onSubmit() {
      // this.form[this.rep].email = this.updated_content;
      this.form[this.rep].email = this.get_html_from_iframe("email_text");
      this.form[this.rep].text = this.form[this.rep].email;
      if (
        !this.form[this.rep].text ||
        this.form[this.rep].text === `<p><br data-mce-bogus="1"></p>` ||
        this.form[this.rep].text === `<p></p>`
      ) {
        this.$showSnackbar({
          preset: "error",
          text: `C'è stato un problema durante il salvataggio. Ti preghiamo di riprovare più tardi.`,
        });
        return;
      }
      this.isSavingTemplate = true;
      this.store()
        .then(() => {
          this.isSavingTemplate = false;
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: Template Email Creato`,
          });
          this.shortcut("lisacomunica_template", null, "#Email", "filterEmail");
        })
        .catch((error) => {
          let errMsg =
            error?.response?.data?.message || this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          this.isSavingTemplate = false;
        });
    },
    setPresetOptions(presets) {
      this.presets = presets.map((preset) => {
        return {
          value: String(preset.id),
          text: preset.title,
          type: preset.type,
          email: preset.text,
          subject: preset.subject,
        };
      });
    },
  },
  mounted() {
    this.isLoading = true;
    this.preset_all()
      .then((response) => {
        this.setPresetOptions(response.data.content);
        this.index("", "image")
          .then((response) => {
            this.setImages(response.data.content);
            this.isLoading = false;
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({
              preset: "error",
              text: `${errMsg}`,
            });
            this.isLoading = false;
          });
      })
      .catch((error) => {
        let errMsg = this.$getErrorMessage(error);
        this.$showSnackbar({
          preset: "error",
          text: `${errMsg}`,
        });
        this.isLoading = false;
      });
  },
  computed: {
    rep() {
      return this.repository;
    },
  },
};
</script>
